/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native'
import * as Linking from 'expo-linking'

const LinkingConfiguration: LinkingOptions<{}> = {
  prefixes: [Linking.makeUrl('/'), "https://lucid-code.com/LucidScribeApp"],
  config: {
    screens: {
      Root: {
        path: "/LucidScribeApp",
        screens: {
          TabOne: {
            screens: {
              TabOneScreen: 'one',
            },
          },
          TabTwo: {
            screens: {
              TabTwoScreen: 'two',
            },
          },
        },
      },
      NotFound: '*',
    },
  },
}

export default LinkingConfiguration
